<app-dialog
  [title]="data.title"
  [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    { text: 'Update', isDisabled: !form.valid }
  ]"
  (action)="dialogAction($event)"
  (close)="dialogRef.close()"
>
  <div [formGroup]="form" class="cases-form">
    <div class="input-container">
      <label for="" class="input-container_label"
        >Total Cases</label
      >
      <input
        type="number"
        class="input-container_input"
        formControlName="receivedQty"
        (keypress)="onlyNumberKey($event)"
        min="1"
      />
    </div>
    <div class="qty" >
      Total Qty: <span>{{ totalQty }}</span>
    </div>
  </div>
</app-dialog>